import React from 'react';
import SvgIcon from './SvgIcon';
import { SvgIconProps } from './types';

const Office365 = (props: SvgIconProps) => (
    <SvgIcon
        {...props}
        fill="none"
        viewBox="4 2 40 44"
        width="40px"
        height="44px"
    >
        {/* Gradients */}
        <radialGradient
            id="o365-a"
            cx="0"
            cy="0"
            gradientTransform="matrix(-11.70018599 31.24700921 -54.50117024 -20.40751562 17.4186 10.6383)"
            gradientUnits="userSpaceOnUse"
            r="1"
        >
            <stop offset=".06441" stopColor="#ae7fe2" />
            <stop offset="1" stopColor="#0078d4" />
        </radialGradient>
        <linearGradient
            id="o365-b"
            gradientUnits="userSpaceOnUse"
            x1="17.5119"
            x2="12.7513"
            y1="37.8685"
            y2="29.6347"
        >
            <stop offset="0" stopColor="#114a8b" />
            <stop offset="1" stopColor="#0078d4" stopOpacity="0" />
        </linearGradient>
        <radialGradient
            id="o365-c"
            cx="0"
            cy="0"
            gradientTransform="matrix(30.71979672 -4.51832042 2.98465285 20.29248048 10.4299 36.3511)"
            gradientUnits="userSpaceOnUse"
            r="1"
        >
            <stop offset=".133928" stopColor="#d59dff" />
            <stop offset="1" stopColor="#5e438f" />
        </radialGradient>
        <linearGradient
            id="o365-d"
            gradientUnits="userSpaceOnUse"
            x1="40.3566"
            x2="35.2552"
            y1="25.3768"
            y2="32.6916"
        >
            <stop offset="0" stopColor="#493474" />
            <stop offset="1" stopColor="#8c66ba" stopOpacity="0" />
        </linearGradient>
        <radialGradient
            id="o365-e"
            cx="0"
            cy="0"
            gradientTransform="matrix(-24.15830194 -6.12555362 10.31179592 -40.66823911 41.0552 26.504)"
            gradientUnits="userSpaceOnUse"
            r="1"
        >
            <stop offset=".0584996" stopColor="#50e6ff" />
            <stop offset="1" stopColor="#436dcd" />
        </radialGradient>
        <linearGradient
            id="o365-f"
            gradientUnits="userSpaceOnUse"
            x1="16.9758"
            x2="24.4868"
            y1="3.05655"
            y2="3.05655"
        >
            <stop offset="0" stopColor="#2d3f80" />
            <stop offset="1" stopColor="#436dcd" stopOpacity="0" />
        </linearGradient>
        {/* Paths */}
        <path
            d="m20.0842 3.02588-.2247.13591c-.3574.2162-.6941.45793-1.0083.72206l.6481-.45587h5.5007l1 7.57202-5 5-5 3.4754v4.0075c0 2.799 1.4629 5.3945 3.8574 6.8439l5.2637 3.1861-11.1211 6.4873h-2.1449l-3.99773-2.4198c-2.39451-1.4494-3.85737-4.0449-3.85737-6.8439v-13.4759c0-2.7999 1.46379-5.3961 3.85952-6.8452l11.99998-7.25853c.0744-.04498.1493-.08864.2247-.13099z"
            fill="url(#o365-a)"
        />
        <path
            d="m20.0842 3.02588-.2247.13591c-.3574.2162-.6941.45793-1.0083.72206l.6481-.45587h5.5007l1 7.57202-5 5-5 3.4754v4.0075c0 2.799 1.4629 5.3945 3.8574 6.8439l5.2637 3.1861-11.1211 6.4873h-2.1449l-3.99773-2.4198c-2.39451-1.4494-3.85737-4.0449-3.85737-6.8439v-13.4759c0-2.7999 1.46379-5.3961 3.85952-6.8452l11.99998-7.25853c.0744-.04498.1493-.08864.2247-.13099z"
            fill="url(#o365-b)"
        />
        <path
            d="m32 19v4.4803c0 2.799-1.4629 5.3945-3.8574 6.8439l-12 7.2636c-2.4548 1.4859-5.5091 1.5395-8.0071.1609l11.7218 7.0953c2.5466 1.5415 5.7386 1.5415 8.2853 0l12-7.2637c2.3945-1.4494 3.8573-4.0449 3.8573-6.8439v-3.2364l-1-1.5z"
            fill="url(#o365-c)"
        />
        <path
            d="m32 19v4.4803c0 2.799-1.4629 5.3945-3.8574 6.8439l-12 7.2636c-2.4548 1.4859-5.5091 1.5395-8.0071.1609l11.7218 7.0953c2.5466 1.5415 5.7386 1.5415 8.2853 0l12-7.2637c2.3945-1.4494 3.8573-4.0449 3.8573-6.8439v-3.2364l-1-1.5z"
            fill="url(#o365-d)"
        />
        <path
            d="m40.1405 10.4153-12-7.25852c-2.4667-1.49207-5.5384-1.53829-8.0426-.13867l-.2384.1442c-2.3957 1.44912-3.8595 4.04526-3.8595 6.84519v9.4839l3.8595-2.3346c2.5456-1.5397 5.7354-1.5397 8.281 0l12 7.2585c2.3208 1.4039 3.7671 3.8841 3.8552 6.5832.0029-.0872.0043-.1745.0043-.2621v-13.4759c0-2.7999-1.4638-5.3961-3.8595-6.8452z"
            fill="url(#o365-e)"
        />
        <path
            d="m40.1405 10.4153-12-7.25852c-2.4667-1.49207-5.5384-1.53829-8.0426-.13867l-.2384.1442c-2.3957 1.44912-3.8595 4.04526-3.8595 6.84519v9.4839l3.8595-2.3346c2.5456-1.5397 5.7354-1.5397 8.281 0l12 7.2585c2.3208 1.4039 3.7671 3.8841 3.8552 6.5832.0029-.0872.0043-.1745.0043-.2621v-13.4759c0-2.7999-1.4638-5.3961-3.8595-6.8452z"
            fill="url(#o365-f)"
        />
    </SvgIcon>
);

export default Office365;
